/* A brief binary curtain bridges the hero and its collection destination. */
(() => {
  if (window.grid94FileTransition) return;
  window.grid94FileTransition = true;

  // Match the neon glow colors of G, R, I, D, and 94 in theme.css.
  const COLORS = ['#39ff14', '#ff2a2a', '#ffd400', '#ffffff', '#2aa8ff'];
  const DURATION = 1600;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = null;

  function reset() {
    if (!active) return;
    cancelAnimationFrame(active.frame);
    clearTimeout(active.navigationTimer);
    clearTimeout(active.recoveryTimer);
    active.overlay.remove();
    active.link.removeAttribute('aria-busy');
    active = null;
  }

  function navigate() {
    if (!active || active.navigating) return;
    active.navigating = true;
    cancelAnimationFrame(active.frame);
    clearTimeout(active.navigationTimer);
    // Recover the original link if the browser cancels or stalls navigation.
    active.recoveryTimer = setTimeout(reset, 8000);
    try {
      sessionStorage.setItem('grid94-file-arrival', JSON.stringify({
        destination: active.destination,
        created: Date.now(),
      }));
    } catch {
      // Navigation remains available when browser storage is disabled.
    }
    window.location.assign(active.destination);
  }

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-file-transition]');
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    if (!link.getAttribute('href') || destination.origin !== window.location.origin ||
        (destination.pathname === window.location.pathname &&
         destination.search === window.location.search) || reducedMotion.matches) return;

    if (active) {
      event.preventDefault();
      return;
    }

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;

    event.preventDefault();
    const overlay = document.createElement('div');
    overlay.className = 'file-transition';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.append(canvas);
    document.body.append(overlay);
    link.setAttribute('aria-busy', 'true');
    active = { overlay, link, destination: destination.href, frame: 0 };

    let width;
    let height;
    let fontSize;
    let spacing;
    let columns;

    function sizeCanvas() {
      width = window.innerWidth;
      height = window.innerHeight;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      fontSize = width < 600 ? 16 : 18;
      spacing = fontSize * 1.4;
      context.font = `600 ${fontSize}px ui-monospace, SFMono-Regular, Menlo, monospace`;
      context.textAlign = 'center';
      columns = Array.from({ length: Math.ceil(width / spacing) }, (_, index) => ({
        x: (index + 0.5) * spacing,
        color: COLORS[index % COLORS.length],
        delay: Math.random() * 240,
        speed: (height + 350) / (850 + Math.random() * 260),
        seed: Math.floor(Math.random() * 1000),
        trail: 14 + Math.floor(Math.random() * 20),
      }));
    }

    sizeCanvas();
    const started = performance.now();

    function draw(now) {
      if (!active || active.navigating) return;
      if (width !== window.innerWidth || height !== window.innerHeight) sizeCanvas();
      const elapsed = now - started;
      context.clearRect(0, 0, width, height);
      context.shadowBlur = 0;
      // The hero disappears underneath the falling code, from top to bottom.
      context.fillStyle = `rgba(5, 5, 5, ${Math.min(0.98, elapsed / 1050)})`;
      context.fillRect(0, 0, width, height);

      columns.forEach(column => {
        const head = (elapsed - column.delay) * column.speed;
        if (head < 0) return;
        const headRow = Math.floor(head / spacing);
        const lastRow = Math.min(headRow, Math.ceil(height / spacing));

        for (let row = 0; row <= lastRow; row += 1) {
          const distance = headRow - row;
          const trail = Math.max(0, 1 - distance / column.trail);
          const shimmer = (row * 17 + column.seed) % 7 === 0 ? 0.16 : 0;
          context.globalAlpha = Math.min(1, 0.16 + shimmer + trail * 0.76);
          context.fillStyle = distance < 2 ? '#ffffff' : column.color;
          context.shadowColor = column.color;
          context.shadowBlur = distance < 3 ? 14 : 0;
          const tick = Math.floor(elapsed / 95);
          const bit = (column.seed + row * 13 + tick * 7) % 11 < 5 ? '0' : '1';
          context.fillText(bit, column.x, row * spacing + (head % spacing));
        }
      });

      context.globalAlpha = 1;
      context.shadowBlur = 0;
      // Resolve to darkness just as the real collection page takes over.
      if (elapsed > 1250) {
        context.fillStyle = `rgba(5, 5, 5, ${Math.min(1, (elapsed - 1250) / 350)})`;
        context.fillRect(0, 0, width, height);
      }
      if (elapsed >= DURATION) {
        navigate();
        return;
      }
      active.frame = requestAnimationFrame(draw);
    }

    active.frame = requestAnimationFrame(draw);
    // Navigation still completes if animation frames pause in a background tab.
    active.navigationTimer = setTimeout(navigate, DURATION + 100);
  });

  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', reset);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches && active) {
      navigate();
      reset();
    }
  });
})();
